// extracted by mini-css-extract-plugin
module.exports = {"smallText":"Item_smallText__Azp1_"};